import { recruiterTheme } from "./recruiter.theme";

export const THEMES = {
  recruiter: recruiterTheme,
};
